import { createSlice } from '@reduxjs/toolkit';
import { KeyboardSliceState, ActiveFocusItemName } from './keyboardSliceTypes';
import { RootState } from '../../rootReducer';

const initialState: KeyboardSliceState = {
  activeFocusItem: null,
};

export const keyboardSlice = createSlice({
  name: 'keyboardState',
  initialState,
  reducers: {
    setActiveFocusItem(state, action) {
      state.activeFocusItem = action.payload;
    },
  },
});

export const selectActiveFocusItem = (state: RootState): ActiveFocusItemName | null =>
  state.keyboardState.activeFocusItem;

export const keyboardActions = keyboardSlice.actions;

export default keyboardSlice.reducer;
